// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__28ZJW","title":"styles_title__3hEo0"};